export default "__VITE_ASSET__d6fa40c4__"